import Reading from "../../../../src/posts/dynamic/reading";
import * as React from 'react';
export default {
  Reading,
  React
};